import { render, staticRenderFns } from "./LargeScreenLayout.vue?vue&type=template&id=0af55a2f&"
import script from "./LargeScreenLayout.vue?vue&type=script&lang=js&"
export * from "./LargeScreenLayout.vue?vue&type=script&lang=js&"
import style0 from "./LargeScreenLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports